import { Dispatch } from 'redux';
import { NotificationActions } from '../store/NotificationSlice';
import { CallLogActions } from '../store/CallLogSlice';
import SetAuthHeader, { ManageResponseErrors } from './actionUtils';
import { AccessToken } from '@okta/okta-auth-js';
import { CallLogSearchParams } from '../components/CallLogs/CallLog';
import { NotificationStatus } from '../components/Notification/Notification';

export const getCallLogs = (searchParams: CallLogSearchParams, apiUrl: string
            , accessToken: AccessToken, curPage: number, rowsPerPage: number, displayNotification: boolean) => {
    return async (dispatch: Dispatch) => {
        const fetchData = async () => {
            if (displayNotification) {
                dispatch(NotificationActions.showNotification({
                    status: 'Searching',
                    title: 'Search',
                    message: 'Fetching CallLog Data'
                }));
            }
            const response = await fetch(`${apiUrl}/api/calllog/getcalllogs?siteCode=${searchParams.SiteId}&start=${searchParams.StartDate}&end=${searchParams.EndDate}&curPage=${curPage}&rowsPerPage=${rowsPerPage}`
                                            , SetAuthHeader(accessToken));

            ManageResponseErrors(response);
            if (response.status === 204) {
                return [];
            }

            const data = await response.json();
            return data;
        };

        const fetchSummaryData = async () => {
            if (displayNotification) {
                dispatch(NotificationActions.showNotification({
                    status: 'Searching',
                    title: 'Search',
                    message: 'Fetching CallLog Summary Data'
                }));
            }
            const response = await fetch(`${apiUrl}/api/calllog/getcalllogsummary?siteCode=${searchParams.SiteId}&start=${searchParams.StartDate}&end=${searchParams.EndDate}`
                , SetAuthHeader(accessToken));

            ManageResponseErrors(response);
            if (response.status === 204) {
                return [];
            }

            const data = await response.json();
            return data;
        };

        try {
            const calls = await fetchData();
            const callsummary = await fetchSummaryData();
            dispatch(CallLogActions.setResultData({ data: calls, subtotal: callsummary }));
            if (displayNotification) {
                dispatch(NotificationActions.showNotification({
                    status: NotificationStatus.Success,
                    title: 'Success',
                    message: 'Completed fetching CallLog Data'
                }));
            }
        }
        catch (error) {
            dispatch(
                NotificationActions.showNotification({
                    status: 'Error',
                    title: 'Error!',
                    message: 'Fetching CallLog Info failed!'
                })
            );
        }
    };
};

export const clearCallLogs = () => {
    return async (dispatch: Dispatch) => {
        dispatch(CallLogActions.clearResultData({ data: [], subtotal: [] }));
    }
}